import { render, staticRenderFns } from "./generalBoard.vue?vue&type=template&id=1de19638&"
import script from "./generalBoard.vue?vue&type=script&lang=js&"
export * from "./generalBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports